import React, { useState } from "react";
import { toast } from "react-toastify";
import _ from "lodash";

import { connect } from "react-redux";
import PActions from "../../Stores/redux/Persisted/Actions";
import UnpActions from "../../Stores/redux/Unpersisted/Actions";

import Modal from "../../Components/Modal/Modal";
import api from "../../Services/Api/api";

const NewVisitorForm = ({ isOpen, onClose, user, onSuccess }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    district: user.district._id,
    name: "",
    officeName: "",
    designation: "",
    phone: "",
    password: "",
    email: "",
    creationDate: Date.now(),
  });

  // Handle Input Change
  const handleChange = (name, value) =>
    setFormData({ ...formData, [name]: value });

  // Submit Form
  const handleSubmit = async () => {
    try {
      if (loading) return;

      setError(null);
      setLoading(true);

      const { user } = await api.post("v1/district-admin/visitor", {
        ..._.pick(formData, [
          "district",
          "name",
          "officeName",
          "designation",
          "phone",
          "password",
          "email",
        ]),
      });
      console.log({ user });
      toast.success("Visitor created successfully");

      setLoading(false);
      onClose(); // Close modal after submit
      if (onSuccess) onSuccess(user);
    } catch (e) {
      setError(e.message);
      setLoading(false);
      toast.error("Error: " + e.message);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Visitor"
      showFooter={false}
      closeOnOutsideClick={false}
    >
      <div className="form-step">
        <label>Full Name</label>
        <input
          type="text"
          placeholder="Enter Full Name"
          value={formData.name || ""}
          onChange={(e) => handleChange("name", e.target.value)}
        />

        <label>Phone</label>
        <input
          type="text"
          placeholder="Enter Phone Number"
          value={formData.phone || ""}
          onChange={({ target: { value } }) => handleChange("phone", value)}
        />

        <label>Password</label>
        <input
          type="password"
          placeholder="Enter Password"
          value={formData.password || ""}
          onChange={({ target: { value } }) => handleChange("password", value)}
        />

        <label>
          Office Name <span className="sub-label">(Optional)</span>
        </label>
        <input
          type="text"
          placeholder="Enter Office Name"
          value={formData.officeName || ""}
          onChange={(e) => handleChange("officeName", e.target.value)}
        />

        <label>
          Designation <span className="sub-label">(Optional)</span>
        </label>
        <input
          type="text"
          placeholder="Enter Designation"
          value={formData.designation || ""}
          onChange={(e) => handleChange("designation", e.target.value)}
        />

        <label>
          Email <span className="sub-label">(Optional)</span>
        </label>
        <input
          type="text"
          placeholder="Enter Email"
          value={formData.email || ""}
          onChange={(e) => handleChange("email", e.target.value)}
        />
      </div>

      <div className="errormsg">{error}</div>

      <div className="modal-footer">
        <button className="cancel-btn" onClick={onClose}>
          Cancel
        </button>
        {formData.name && formData.phone && formData.password && (
          <button className="submit-btn" onClick={handleSubmit}>
            {loading ? "Loading.." : "Submit"}
          </button>
        )}
      </div>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  user: state.pState.AUTH.user,
});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = "USERS_SCREEN") =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewVisitorForm);
